<wms-dialog id="vcsFilesListByCommitDialog" customClasses="large commit-changes-container-dialog">
    <wms-dialog-header (onClose)="vcsService.closeDialogWithId('vcsFilesListByCommitDialog')"
        title="{{locale['LABEL_VCS_VIEW_COMMIT_CHANGES']}}" helpTitle="{{locale['LABEL_VCS_VIEW_COMMIT_CHANGES']}}"
        helpLink="https://docs.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#view-changes"
        customClass="pullChanges-header"></wms-dialog-header>
    <wms-dialog-body>
        <form enctype="multipart/form-data" name="statusVCSProject" class="wm-form status-vcs-project">
            <div class="form-group clearfix">
                <p class="text-muted"><strong>{{locale['LABEL_COMMIT_ID']}}</strong>: {{selectedCommit.commitId}}</p>
                <p class="text-muted"><strong>{{locale['LABEL_COMMIT_DATE']}}</strong>: {{ selectedCommit.commitTime *
                    1000 | date: 'MMM d, y hh:mm'}}</p>
                <p class="text-muted"><strong>{{locale['LABEL_COMMIT_AUTHOR']}}</strong>: {{selectedCommit.author.name}}
                </p>
            </div>
            <wms-view-changes-table [fileList]="vcsService.commitHistoryChanges" [showCommitedFile]="true" [commit]="selectedCommit" [commitId]="selectedCommit.commitId"></wms-view-changes-table>
        </form>
    </wms-dialog-body>
    <wms-dialog-footer>
        <button class="btn button-secondary app-button"
            (click)="vcsService.closeDialogWithId('vcsFilesListByCommitDialog')">{{locale['LABEL_CLOSE']}}</button>
    </wms-dialog-footer>
</wms-dialog>
